import classNames from 'classnames'
import {Button} from '../../Button'
import {HiChevronRight, HiChevronLeft} from 'react-icons/hi'
import type {CommonProps} from '../../@types/common'
import {ReactNode} from "react";

export interface HeaderProps extends CommonProps {
    hasNext: boolean
    hasPrevious: boolean
    onNext?: () => void
    onPrevious?: () => void
    onNextLevel?: () => void
    label?: string
    nextLevelDisabled?: boolean
    previousLabel?: string
    preventLevelFocus?: boolean
    renderCenter?: boolean
    preventFocus?: boolean
    prevIcon?: ReactNode
    prevLabel?: ReactNode
    nextIcon?: ReactNode
    nextLabel?: ReactNode
}

const Header = (props: HeaderProps) => {
    const {
        hasNext,
        hasPrevious,
        onNext,
        onPrevious,
        onNextLevel,
        label,
        nextLevelDisabled,
        previousLabel,
        preventLevelFocus = false,
        renderCenter = false,
        preventFocus,
        children,
        className,
        prevIcon,
        prevLabel,
        nextIcon,
        nextLabel,
        ...rest
    } = props

    const headerLabel = (
        <button
            className="picker-header-label"
            disabled={nextLevelDisabled}
            tabIndex={preventLevelFocus ? -1 : 0}
            type="button"
            onClick={onNextLevel}
            onMouseDown={(event) => preventFocus && event.preventDefault()}
        >
            {label}
        </button>
    )

    const renderChildren = children ? children : headerLabel

    return (
        <div
            className={classNames(
                'picker-header flex items-center justify-between mb-2',
                className
            )}
            {...rest}
        >
            {!renderCenter && renderChildren}
            <div
                className={classNames(
                    renderCenter && 'justify-between w-full',
                    'flex items-center rtl:flex-row-reverse'
                )}
            >
                <Button
                    type="button"
                    variant="plain"
                    className={classNames(
                        !hasNext && renderCenter && 'opacity-0 cursor-default'
                    )}
                    size="sm"
                    disabled={!hasNext}
                    aria-label={nextLabel}
                    onClick={onNext}
                    onMouseDown={(event) =>
                        preventFocus && event.preventDefault()
                    }
                >
                    <div className={"flex gap-1"}>{nextLabel} {nextIcon || <HiChevronLeft size={18}/>}</div>
                </Button>
                {renderCenter && renderChildren}
                <Button
                    type="button"
                    variant="plain"
                    className={classNames(
                        !hasPrevious &&
                        renderCenter &&
                        'opacity-0 cursor-default'
                    )}
                    size="sm"
                    disabled={!hasPrevious}
                    aria-label={previousLabel}
                    onClick={onPrevious}
                    onMouseDown={(event) =>
                        preventFocus && event.preventDefault()
                    }
                >
                    <div className={"flex gap-1"}>{prevIcon || <HiChevronRight size={18}/>} {prevLabel}</div>
                </Button>
            </div>
        </div>
    )
}

export default Header
